import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from "react-dom";
import { INFOBUBBLE_MODE } from "./constants";
import { InfoBubbleBody } from "./InfoBubbleBody";
import { setAnnotationPresent } from "../../../../store/reducers/jsMapSlice";
import { saveUserAnnotateInfo } from "../../../../pages/JsMapCreator/helper";
export var saveInfoContent = function (bubble, description, dispatchEvent) {
    var div = document.createElement("div");
    ReactDOM.render(_jsx(InfoBubbleBody, { mode: INFOBUBBLE_MODE.EDIT, bubble: bubble, desp: description, dispatchEvent: dispatchEvent }), div);
    bubble === null || bubble === void 0 ? void 0 : bubble.setContent(div);
    var obj = bubble === null || bubble === void 0 ? void 0 : bubble.getData();
    bubble.setData({
        geometry: obj === null || obj === void 0 ? void 0 : obj.geometry,
        position: obj === null || obj === void 0 ? void 0 : obj.position,
        marker: obj === null || obj === void 0 ? void 0 : obj.marker,
        description: description,
    });
    dispatchEvent(setAnnotationPresent(true));
    saveUserAnnotateInfo(bubble);
};
export var editInfoContent = function (bubble, desp, dispatchEvent) {
    var div = document.createElement("div");
    ReactDOM.render(_jsx(InfoBubbleBody, { mode: INFOBUBBLE_MODE.SAVE, bubble: bubble, desp: desp, dispatchEvent: dispatchEvent }), div);
    bubble.setContent(div);
};
